type GAEventParams = {
  eventAction?: string;
  eventCategory?: string;
  hitType?: string;
  hostname?: string;
  page?: string;
};

type WindowWithGA = Window & {
  ga?: (command: string, params: GAEventParams) => void;
};

export const trackGAEvent = (params: GAEventParams) => {
  const ga = (<WindowWithGA>window).ga;
  if (typeof ga !== 'function') {
    console.warn("FLMPiano.trackGAEvent: 'ga' is not available");
    return;
  }

  const { hostname, pathname, search } = window.location;

  ga('send', {
    eventAction: 'click',
    eventCategory: 'piano',
    hitType: 'event',
    hostname,
    page: `${pathname}${search}`,
    ...params,
  });
};
